<template>
  <div class="modal-card">
    <section class="modal-card-body">
      <p class="modal-card-title">{{ product.title }}</p>
      <hr class="line" />
      <p class="details">
        <b>Valor:</b> R$ {{ product.metadata.price }} <br />
        <b>Tamanho:</b> {{ product.metadata.size }} cm <br />
        <b>Tempo de produção:</b>
        {{
          product.metadata.production_time === ''
            ? '-'
            : product.metadata.production_time + ' dias' || '-'
        }}
        <br />
      </p>
      <p :class="`type-tag ${product.metadata.on_demand ? 'on_demand' : 'available'}`">
        {{ product.metadata.on_demand ? 'Sob Encomenda' : 'Pronta entrega' }}
      </p>
      <b-carousel
        :pause-info="false"
        :indicator="true"
        :indicator-background="false"
        :indicator-inside="false"
        indicator-mode="hover"
        indicator-style="is-dots"
        indicator-position="is-bottom"
        icon-pack="mdi"
      >
        <b-carousel-item v-for="(image, index) in product.metadata.images" :key="index">
          <section :class="`hero is-small`">
            <img :src="image.image.url" alt="Imagem do produto" class="image" />
          </section>
        </b-carousel-item>
      </b-carousel>
    </section>
  </div>
</template>

<script scoped>
export default {
  props: ['product'],
};
</script>

<style>
.product-modal .modal-card {
  font-family: 'Poppins', sans-serif;
  border-radius: 10px;
  width: 450px;
}

.modal-card-body {
  padding: 40px 30px;
}

.line {
  width: 55px;
  margin: 10px 10px;
  border: 1px solid rgb(224, 224, 224);
}

.type-tag {
  width: 140px;
  font-size: 13px;
  margin: 10px 0 15px;
  color: white;
  border-radius: 15px;
  padding: 3px 8px;
  text-align: center;
}

.on_demand {
  background-color: #469abb;
}

.available {
  background-color: #48c55d;
}

.image {
  width: 400px;
  height: 300px;
  object-fit: cover;
  margin: auto;
}

@media screen and (max-width: 560px) {
  .product-modal .modal-card {
    width: 310px;
  }

  .modal .animation-content .modal-card {
    margin: auto;
  }
}
</style>
